module.exports = __webpack_public_path__ + "static/media/tamboril.abbd5b57.jpeg";